import { Add } from "@mui/icons-material";
import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Link,
  Modal,
  ModalDialog,
} from "@mui/joy";
import { HTTPError } from "griptonite-api-client/client";
import { useState } from "react";

import { useVenueCreditSystemQuery } from "@/hooks/credits";
import { useCurrentVenueUuid } from "@/hooks/venues";

import { ButtonLink } from "../Links";
import { SUPPORT_EMAIL } from "../ManageCreditSystem/ManageCreditSystem";

// Quests pay out credits, so the API won't create one at a venue without a credit system. That's
// only known once the credit system has 404'd; until then the button goes straight to the form.
export default function AddQuestButton() {
  const venueUuid = useCurrentVenueUuid();
  const { error } = useVenueCreditSystemQuery(venueUuid);
  const hasNoCreditSystem = error instanceof HTTPError && error.response.status === 404;
  const [isModalOpen, setIsModalOpen] = useState(false);

  if (!hasNoCreditSystem) {
    return (
      <ButtonLink
        from="/gym/$venueUuid/loyalty/quests/"
        to="/gym/$venueUuid/loyalty/quests/create"
        startDecorator={<Add />}
      >
        Add quest
      </ButtonLink>
    );
  }

  return (
    <>
      <Button startDecorator={<Add />} onClick={() => setIsModalOpen(true)}>
        Add quest
      </Button>
      <Modal open={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <ModalDialog sx={{ maxWidth: 440 }}>
          <DialogTitle>Set up credits first</DialogTitle>
          <DialogContent>
            Quests reward climbers with credits, and credits aren’t set up for this gym yet. To get
            started, contact <Link href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</Link>.
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setIsModalOpen(false)}>OK</Button>
          </DialogActions>
        </ModalDialog>
      </Modal>
    </>
  );
}
